import UIDs from "../../../../../../UIDs";

const uid = UIDs.screens.admin.dictionary.letter.edit;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    SAVE_LETTERS_ASYNC: `${uid}.saveLettersAsync`,
    SAVE_LETTERS_SUCCESS: `${uid}.saveLettersSuccess`,
    SAVE_LETTERS_FAILURE: `${uid}.saveLettersFailure`,
    BATCH_ADD_LETTERS_ASYNC: `${uid}.batchAddLettersAsync`,
    BATCH_ADD_LETTERS_SUCCESS: `${uid}.batchAddLettersSuccess`,
    BATCH_ADD_LETTERS_FAILURE: `${uid}.batchAddLettersFailure`,
    CREATE_LETTERS: `${uid}.createLetters`
};

export { ActionTypes };
